(function () {
  'use strict';

  if (window.MsPremiumCategoryList) {
    window.MsPremiumCategoryList.initAll(document);
    return;
  }

  function initList(root) {
    if (!root || root.dataset.premiumCategoryReady === 'true') return;

    var scroller = root.querySelector('[data-premium-category-scroller]');
    var prev = root.querySelector('[data-premium-category-prev]');
    var next = root.querySelector('[data-premium-category-next]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-premium-category-card]'));
    var resizeTimer = null;
    var initialTimer = null;
    var observer = null;
    var destroyed = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!scroller || !cards.length) return;
    root.dataset.premiumCategoryReady = 'true';

    function cardStep() {
      if (!cards[0]) return scroller.clientWidth;
      var rect = cards[0].getBoundingClientRect();
      var track = scroller.querySelector('.premium-category-list__track') || scroller;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return rect.width + gap;
    }

    function updateControls() {
      if (destroyed) return;
      var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth - 2);
      var left = scroller.scrollLeft;
      var hasOverflow = maxScroll > 4;

      root.classList.toggle('is-scrollable', hasOverflow);

      if (prev) prev.disabled = !hasOverflow || left <= 2;
      if (next) next.disabled = !hasOverflow || left >= maxScroll;
    }

    function cardsPerStep() {
      var step = cardStep();
      if (!step) return 1;
      var visible = scroller.clientWidth / step;
      return Math.max(1, Math.floor(visible));
    }

    function scrollByCards(direction) {
      scroller.scrollBy({
        left: direction * cardStep() * cardsPerStep(),
        behavior: reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    function scheduleUpdate() {
      if (destroyed) return;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateControls, 80);
    }

    function previousCards() {
      scrollByCards(-1);
    }

    function nextCards() {
      scrollByCards(1);
    }

    if (prev) prev.addEventListener('click', previousCards);
    if (next) next.addEventListener('click', nextCards);

    scroller.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(scheduleUpdate);
      observer.observe(scroller);
      cards.forEach(function (card) {
        observer.observe(card);
      });
    }

    root.premiumCategoryDestroy = function () {
      destroyed = true;
      window.clearTimeout(resizeTimer);
      window.clearTimeout(initialTimer);
      if (observer) observer.disconnect();
      if (prev) prev.removeEventListener('click', previousCards);
      if (next) next.removeEventListener('click', nextCards);
      scroller.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      delete root.dataset.premiumCategoryReady;
      delete root.premiumCategoryDestroy;
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate).catch(function () {});
    }

    updateControls();
    initialTimer = window.setTimeout(updateControls, 250);
  }

  function forEachList(root, callback) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-premium-category-list]')) callback(scope);
    scope.querySelectorAll('[data-premium-category-list]').forEach(callback);
  }

  function initAll(root) {
    forEachList(root, initList);
  }

  function destroyAll(root) {
    forEachList(root, function (list) {
      if (list.premiumCategoryDestroy) list.premiumCategoryDestroy();
    });
  }

  window.MsPremiumCategoryList = {
    initAll: initAll,
    destroyAll: destroyAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event && event.target) destroyAll(event.target);
  });
})();
